/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import main_logo from "../../assets/images/logo.png";
import { Link } from "react-router-dom";
import "./index.scss";



/**
 * @desc Module "Home page".
 * @return {JSX.Element} - module that includes a default page, when user opens the web-app
 */


const ErrorOccured = () => {
    return (<>
        <div className="containerError">
            <div className="container text-center">
                <Link to={"/"}><img src={main_logo} alt="" /></Link>
                <div className="header">Помилка</div>
                <p />
                Сторінку не знайдено
            </div>
        </div>

    </>)

}

export default ErrorOccured;


